export default __webpack_public_path__ + "static/media/projects.88ce9191.svg";